"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var xml_utils_1 = require("xml-utils");
var find_operation_1 = __importDefault(require("./find-operation"));
var utils_1 = require("../utils");
function findAndParseOperationUrl(xml, op, method) {
    var _a;
    if (method === void 0) { method = "Get"; }
    var xmlOp = (0, find_operation_1.default)(xml, op);
    if (!xmlOp) {
        return undefined;
    }
    var xmlMethod = (_a = (0, xml_utils_1.findTagByName)(xmlOp, "ows:".concat((0, utils_1.titlecase)(method)))) === null || _a === void 0 ? void 0 : _a.outer;
    if (!xmlMethod) {
        return undefined;
    }
    return (0, xml_utils_1.getAttribute)(xmlMethod, "xlink:href");
}
exports.default = findAndParseOperationUrl;
